import React, { useEffect, useRef } from 'react';

const AD_CLIENT = 'ca-pub-5873506825804093';

/**
 * In-feed ad card that blends with the bookmark grid.
 * Auto-format: Google picks the best ad size for the container.
 */
export function InFeedAd({ className = '' }) {
  const adRef = useRef(null);
  const pushed = useRef(false);

  useEffect(() => {
    if (pushed.current) return;
    try {
      if (adRef.current && window.adsbygoogle) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        pushed.current = true;
      }
    } catch (e) {
      // AdSense not loaded or ad blocker
    }
  }, []);

  return (
    <div className={`bg-white border border-border/80 rounded-2xl overflow-hidden shadow-card ${className}`} data-testid="ad-infeed">
      <div className="p-1">
        <ins
          ref={adRef}
          className="adsbygoogle"
          style={{ display: 'block' }}
          data-ad-client={AD_CLIENT}
          data-ad-slot="auto"
          data-ad-format="fluid"
          data-ad-layout-key="-6t+ed+2i-1n-4w"
        />
      </div>
      <div className="px-3 pb-2">
        <span className="text-[10px] text-muted-foreground/50 uppercase tracking-wider">Sponsored</span>
      </div>
    </div>
  );
}

/**
 * Bottom banner ad for detail pages.
 * Responsive horizontal banner.
 */
export function BannerAd({ className = '' }) {
  const adRef = useRef(null);
  const pushed = useRef(false);

  useEffect(() => {
    if (pushed.current) return;
    try {
      if (adRef.current && window.adsbygoogle) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        pushed.current = true;
      }
    } catch (e) {}
  }, []);

  return (
    <div className={`w-full ${className}`} data-testid="ad-banner">
      <div className="text-center">
        <span className="text-[10px] text-muted-foreground/40 uppercase tracking-wider">Sponsored</span>
      </div>
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={AD_CLIENT}
        data-ad-slot="auto"
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}
